//const ASSETS_PATH = `${window.location.origin}/assets`;
const ASSETS_PATH = `${process.env.REACT_APP_ASSETS_PATH}`;

export {ASSETS_PATH};